import React from 'react';
import { Outlet } from 'react-router-dom';

const StudioLayout = () => {
  return (
    // 🟢 Un layout simple que ocupa toda la pantalla, perfecto para una experiencia inmersiva.
    <div className="min-h-screen bg-gray-900 text-white">
      <Outlet />
    </div>
  );
};

export default StudioLayout;
